<template>
  <div>
    <section class="bg-[#95C24D] p-8 hidden lg:block">
      <div class="flex justify-evenly w-full mx-auto max-w-7xl">
        <div class="w-[25%]">
          <a href="/"><img src="../assets/logo.webp" alt class="bg-white p-6 rounded-md" /></a>
        </div>
        <div class="flex w-[75%] justify-evenly gap-3">
          <div class="border-r w-[25%]">
            <div class="text-start">
              <h3 class="text-lg font-bold text-white">YENEPOYA Online</h3>
            </div>
            <div class="pt-3">
              <ul class="flex flex-col gap-3 text-start">
                <li class="text-white text-base">
                  <a href="/about-us">About Us</a>
                </li>
                <li class="text-white text-base">
                  <a href="/blogs">Blogs</a>
                </li>

                <!-- <li class="text-white text-base">
                  <a href="#rank">Rankings and Recognitions</a>
                </li> -->
                <!-- <li class="text-white text-base">
                  <a href="https://apply.onlineyenepoya.com/" target="_blank" class="">Apply Now</a>
                </li> -->
                <div>
                  <a @click="handleRedirect" class="text-white text-base cursor-pointer">Apply Now</a>
                </div>
              </ul>
            </div>
          </div>

          <div class="w-[25%] border-r">
            <div class="text-start">
              <h3 class="text-lg font-bold text-white">SUPPORT</h3>
            </div>
            <div class="pt-3">
              <ul class="flex flex-col gap-3 text-start">
                <li class="text-white text-base">
                  <a href="/contactus">Contact Us</a>
                </li>
                <li class="text-white text-base">
                  <a href="https://yenepoya.apna.co/" target="_blank">Apna Advantage</a>
                </li>
                <li @click="is_widget = true">
                  <button class="block text-white" href="../brochure/Yenapoya-overall-brochure.pdf"
                    target="_blank">Download Brochure</button>

                </li>
                <li class="text-white text-base">
                  <a href="mailto:info@onlineyenepoya.com" class="">info@onlineyenepoya.com</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="w-[25%]">
            <div class="text-start">
              <h3 class="text-lg font-bold text-white">QUICK LINKS</h3>
            </div>
            <div class="pt-3">
              <ul class="flex flex-col gap-3 text-start">
                <li class="text-white text-base">
                  <a href="/disclosures">Disclosures</a>
                </li>
                <li class="text-white text-base">
                  <a href="/refund-policy">Refund Policy</a>
                </li>
                <li class="text-white text-base">
                  <a href="/yenepoya-online-loan-disclaimer.pdf">Loan T&C</a>
                </li>
                <li class="text-white text-base">
                  <a href="/academic-corner">Academic Corner</a>
                </li>
                <li class="text-white text-base">
                  <a href="/enrollment-data">Enrollment Data</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-[#635F60] md:block hidden">
      <div class="mx-auto max-w-7xl flex justify-between p-4">
        <p class="text-white text-sm">Copyright © 2025 yenepoya.edu.in All Right Reserved.</p>
        <p class="text-white text-sm">Privacy Policy </p>
      </div>
    </section>

    <section>
      <div class="text-center mx-auto justify-center lg:hidden text-white bg-[#95C24D] p-4 mb-8">
        <div class="justify-center flex mx-auto px-6 pb-4 object-cover items-center">
          <a href="/"><img src="../assets/logo.webp" alt class="bg-white p-6 w-[250px] rounded-md" /></a>
        </div>
        <div id="accordion-collapse" class="" data-accordion="collapse">
          <div id="accordion-collapse-heading-12" class="">
            <button type="button" id="b12"
              class="flex items-center justify-between w-[300px] p-3 font-medium text-center text-white  mx-auto border-b !bg-transperant"
              data-accordion-target="#accordion-collapse-body-12" aria-expanded="true"
              aria-controls="accordion-collapse-body-12 ">
              <p class="text-white font-bold ">YENEPOYA ONLINE</p>
              <img src="../assets/arrow-down.png" alt class="object-contain w-6" />
            </button>
          </div>
          <div id="accordion-collapse-body-12" class="hidden  justify-center"
            aria-labelledby="accordion-collapse-heading-12">

            <ul class="py-2 text-left text-lg bg-[#86ae45] text-white w-[300px] divide-y mx-auto justify-center"
              aria-labelledby="dropdownDefaultButton">
              <li>
                <a href="/about-us" class="block px-4 py-2">About Us</a>
              </li>
              <!-- <li>
                  <a href="/programs" class="block px-4 py-2">Online Program</a>
                </li> -->
              <li>
                <a href="/blogs" class="block px-4 py-2">Blogs</a>
              </li>
              <!-- <li>
                  <a href="#" class="block px-4 py-2">Rankings and recognitions</a>
                </li> -->


              <li>
                <a href="https://apply.onlineyenepoya.com/" target="_blank" class="block px-4 py-2">Apply Now</a>
              </li>

            </ul>
          </div>


          <div id="accordion-collapse-heading-18" class="">
            <button type="button" id="b18"
              class="flex items-center justify-between w-[300px] p-3 font-medium text-center mx-auto text-white"
              data-accordion-target="#accordion-collapse-body-18" aria-expanded="false"
              aria-controls="accordion-collapse-body-4">
              <p class="text-white font-bold">SUPPORT</p>
              <img src="../assets/arrow-down.png" alt class="object-contain w-6" />
            </button>
          </div>
          <div id="accordion-collapse-body-18" class="hidden" aria-labelledby="accordion-collapse-heading-18">
            <ul class="py-2 text-left text-lg bg-[#86ae45] ttext-white divide-y w-[300px] text-white mx-auto "
              aria-labelledby="dropdownDefaultButton">
              <li>
                <a href="/contactus" class="block px-4 py-2">Contact Us</a>
              </li>
              <li>
                <a href="https://yenepoya.apna.co/" target="_blank" class="block px-4 py-2">Apna Advantage</a>
              </li>
              <li @click="is_widget = true">
                <button class="block px-4 py-2" href="https://api.onlineyenepoya.com/media/2015/overall-brochure.pdf"
                  target="_blank">Download Brochure</button>

              </li>
              <li @click="is_widget = true">
                <a href="mailto:info@onlineyenepoya.com" class="block px-4 py-2">info@onlineyenepoya.com</a>
              </li>
              <!-- <li>
                <a href="https://learn.onlineyenepoya.com/" class="block px-4 py-2"  target="_blank">LMS Login</a>
              </li>
              -->
            </ul>
          </div>

          <div id="accordion-collapse-heading-19" class="">
            <button type="button" id="b18"
              class="flex items-center justify-between w-[300px] p-3 font-medium text-center mx-auto text-white"
              data-accordion-target="#accordion-collapse-body-19" aria-expanded="false"
              aria-controls="accordion-collapse-body-4">
              <p class="text-white font-bold">QUICK LINKS</p>
              <img src="../assets/arrow-down.png" alt class="object-contain w-6" />
            </button>
          </div>
          <div id="accordion-collapse-body-19" class="hidden" aria-labelledby="accordion-collapse-heading-19">
            <ul class="py-2 text-left text-lg bg-[#86ae45] text-white divide-y w-[300px] text-white mx-auto "
              aria-labelledby="dropdownDefaultButton">
              <li>
                <a href="/disclosures" class="block px-4 py-2">Disclosures</a>
              </li>
              <li>
                <a href="/academic-corner" class="block px-4 py-2">Academic Corner</a>
              </li>

              <li>
                <a href="/enrollment-data" class="block px-4 py-2" target="_blank">Enrollment Data</a>
              </li>
              <li>
                <a href="/yenepoya-online-loan-disclaimer.pdf" class="block px-4 py-2">Loan T&C</a>
              </li>

            </ul>
          </div>

          <div class="mx-auto mx-8 p-4 mb-4">
            <p class="text-white text-sm">Copyright © 2025 yenepoya.edu.in All Right Reserved.- <span><a
                  href="#">Privacy Policy</a></span></p>

          </div>
        </div>
      </div>
    </section>
    <!--bottom navigation-->
    <section>
      <div
        class="fixed bottom-0 left-0 z-50 w-full h-16 bg-[#635F60] border-t mt-5 border-gray-200 dark:bg-gray-700 dark:border-gray-600 lg:hidden">
        <div class="flex h-full max-w-lg justify-center mx-auto font-medium">
          <a href="tel:+919036009258" type="button"
            class="flex-1 inline-flex flex-col items-center justify-center px-5 border-r border-gray-200 hover:bg-[#94C34D] dark:hover:bg-[#94C34D] group dark:border-gray-600">
            <img src="../assets/icos/mobile_phone_icon.webp" class="w-[25px] pt-2" alt="" />
            <span class="text-sm text-white group-hover:text-gray-600 dark:group-hover:text-blue-500">Call</span>
          </a>

          <a type="button" href="https://api.whatsapp.com/send/?phone=919036009258&amp;text&amp;app_absent=0"
            target="_blank"
            class="flex-1 inline-flex flex-col items-center justify-center px-5 hover:bg-[#94C34D] dark:hover:bg-[#94C34D] group">
            <img src="../assets/icos/mobile_whatsapp_icon.webp" class="w-[25px] pt-2" alt="" />
            <span class="text-sm text-white group-hover:text-gray-600 dark:group-hover:text-blue-500">Whatsapp</span>
          </a>

          <!-- <a href="/" class="flex-1">
            <button type="button"
              class="w-full inline-flex flex-col items-center justify-center border-x border-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800 group dark:border-gray-600">
              <img src="../assets/icos/mobile_council_icon.webp" class="w-[25px] pt-2" alt="" />
              <span
                class="text-sm text-white group-hover:text-gray-600 dark:group-hover:text-blue-500">Counselling</span>
            </button>
          </a> -->
        </div>

      </div>
    </section>


    <downloadBrochure v-if="is_widget" @closeModel="is_widget = false"></downloadBrochure>
  </div>
</template>


<script>
import downloadBrochure from "../components/DownloadBrochure.vue"
export default {
  name: "FooterView",
  components: { downloadBrochure },
  data() {
    return {
      is_widget: false,
    };
  },
  methods: {
    handleRedirect() {
      const currentUrl = window.location.href;
      const targetUrlWithSrc = "https://gcc.onlineyenepoya.com/apply-now.php";
      const targetUrlWithoutSrc = "https://apply.onlineyenepoya.com/";

      const finalUrl = currentUrl.includes("src=landing") ? targetUrlWithSrc : targetUrlWithoutSrc;

      window.open(finalUrl, "_blank", "noopener,noreferrer");
    }
  }
}
</script>

<style>
#accordion-collapse .bg-gray-100 {
  background-color: #635f60;
}
</style>